// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1vpuS","row":"styles_row___4Rdi"};